import { difference } from 'underscore';
import { Logger } from './logger';
import { DELIBERATE_CLOSE, getWebsocketUrlForPark } from './webSocket.utils';
import { rematchStore } from 'models/rematchStore';
import { rematchActionDispatcher } from './webSocket.parser';
import ReconnectingWebSocket from 'reconnecting-websocket';

const webSocketsByPark = {};

const isRunningInCypress = () => !!window.Cypress;

const getWebSocket = () => {
    return isRunningInCypress() ? window.MockedWebSocket : window.WebSocket;
};

export const getOrCreateWebSocketForPark = (selectedPark, token) => {
    const parkName = selectedPark.toLowerCase();

    let webSocket = webSocketsByPark[parkName];
    if (webSocket) {
        Logger.info(`WebSocket (${parkName}) already created!`);
        return webSocket;
    }

    if (!token) {
        Logger.warn(`WebSocket (${parkName}) token not found!`);
        return null;
    }

    const URL = getWebsocketUrlForPark(parkName, token);
    webSocket = new ReconnectingWebSocket(URL, undefined, { WebSocket: getWebSocket() });

    webSocket.onopen = () => {
        Logger.debug(`WebSocket (${parkName}) connected!`);
        webSocketsByPark[parkName] = webSocket;
    };
    // isDisconnected should have reconnect true, except when we are manually closing
    webSocket.onclose = (closeEvent) => {
        if (closeEvent.code !== DELIBERATE_CLOSE) {
            Logger.warn(`WebSocket (${parkName}) closed!`, closeEvent);
        } else {
            Logger.debug(`WebSocket (${parkName}) deliberately closed!`);
        }
        Logger.debug(`WebSocket (${parkName}) removing instance!`);
        delete webSocketsByPark[parkName];
    };
    webSocket.onerror = (error) => {
        Logger.warn(`WebSocket (${parkName}) error:`, error);
    };
    webSocket.onmessage = ({ data }) => {
        // Logger.debug(`WebSocket (${parkName}) received data:`, data);

        rematchActionDispatcher(rematchStore.dispatch, JSON.parse(data), parkName);
    };

    webSocketsByPark[parkName] = webSocket;

    return webSocket;
};

export const removeWebSocketForPark = (selectedPark) => {
    const parkName = selectedPark.toLowerCase();

    const webSocket = webSocketsByPark[parkName];
    if (!webSocket) {
        Logger.warn(`WebSocket (${parkName}) not found!`);
        return;
    }

    webSocket.close(DELIBERATE_CLOSE, 'Deliberate disconnection');
};

export const getWebSocketForPark = (selectedPark) => {
    const parkName = selectedPark.toLowerCase();

    const webSocket = webSocketsByPark[parkName];
    if (!webSocket) {
        Logger.warn(`WebSocket (${parkName}) not found!`);
    }

    return webSocket;
};

export const updateWebSocketForParks = (selectedParksTemp, token) => {
    const currentParks = Object.keys(webSocketsByPark);
    const selectedParks = selectedParksTemp.map((item) => item.toLowerCase());

    const parksToRemove = difference(currentParks, selectedParks);
    const parksToAdd = difference(selectedParks, currentParks);

    Logger.debug('WebSocket parksToRemove:', parksToRemove);
    Logger.debug('WebSocket parksToAdd:', parksToAdd);

    parksToRemove.forEach((selectePark) => {
        removeWebSocketForPark(selectePark);
    });
    parksToAdd.forEach((selectePark) => {
        getOrCreateWebSocketForPark(selectePark, token);
    });
};
